import React, { Component } from "react";
import { withRouter, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import * as tgCdes from "../consts/widetcodes";
import * as wActs from "../actions/website-actions";

class LinkHeader extends Component {

  constructor(props) {
    super(props);
    this.state = {

    };
  }

  changeChannel(e,sel) {
    this.props.history.push(tgCdes.Channels[e.target.selectedIndex].url);
  }

  getTranslation(key) {
    return this.props.WebPage.Translations[key];
  }


  render() {

    return (
      <React.Fragment>
        <p className="title text-center" style={{fontSize: "14px", fontWeight: "bold"}}>
          {tgCdes.Channels.map((c,ic) => {
            return <Link to={c.url} className="blue">{ic!=0 && <i className="fa fa-circle blue" style={{fontSize: "6px", verticalAlign: "middle", margin: "2px 10px"}}></i>}{this.getTranslation(c.tKey)}</Link>
          })}
        </p>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    WebPage: state.Website,
    ServerParams: state.Website.ServerParams
  };
}

export default withRouter(connect(mapStateToProps)(LinkHeader));
